var _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _g5, _path6, _path7, _path8, _g6, _g7, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _g8, _g9, _g0, _g1, _g10, _path14, _g11, _g12, _path15, _path16, _path17, _g13, _g14, _g15, _g16, _path18, _path19, _path20, _g17, _g18, _path21, _path22, _path23, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfficeWorker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_821_34938)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1704 12.7406C23.3829 12.3054 23.4942 11.8197 23.4942 11.3137C23.4942 10.8464 23.3981 10.4079 23.2257 10.0082H23.231C23.1505 9.82721 23.0601 9.65621 22.9498 9.49521L22.9477 9.49208C22.6036 8.96584 22.4215 8.34852 22.4215 7.72107V7.71095C22.4215 5.88935 20.944 4.41182 19.1224 4.41182C18.9402 4.41182 18.7682 4.33086 18.667 4.17906C18.0699 3.34922 17.0881 2.80273 15.985 2.80273C14.882 2.80273 13.9003 3.34922 13.3032 4.17906C13.202 4.32074 13.03 4.41182 12.8478 4.41182C12.8194 4.41182 12.7911 4.41218 12.7628 4.4129C10.9805 4.45802 9.54869 5.91777 9.54869 7.71095V7.72107C9.54869 8.34852 9.36653 8.96584 9.02245 9.49208L9.02016 9.49575C8.67753 10.0212 8.47607 10.6372 8.47607 11.3137C8.47607 11.8298 8.59751 12.3054 8.79992 12.7406C8.87076 12.8823 8.87076 13.0543 8.79992 13.196C8.59751 13.6211 8.47607 14.0967 8.47607 14.6027C8.47607 16.3838 9.91312 17.8209 11.6942 17.8209H20.276C22.0572 17.8209 23.4942 16.3838 23.4942 14.6027C23.4942 14.0967 23.3728 13.6211 23.1704 13.196C23.0995 13.0543 23.0995 12.8823 23.1704 12.7406ZM10.9102 10.0682H10.8979L12.0966 12.4237C12.2199 15.2263 13.3136 12.4237 15.985 12.4237C18.6565 12.4237 19.8214 15.5431 19.9447 12.7406L21.0806 9.54348C21.0269 8.29864 20.1248 8.21127 19.9447 8.21127H16.7247C15.4531 8.21127 14.2533 7.58889 13.5354 6.53798C13.4124 6.36453 13.156 6.39514 13.074 6.58899L12.9919 6.78285C12.7663 7.34402 12.3356 7.77254 11.8024 8.01741C11.787 8.02252 11.7691 8.03017 11.7511 8.03782C11.7332 8.04547 11.7152 8.05312 11.6998 8.05823C11.464 8.18066 10.9102 8.54797 10.8897 9.49685L10.9 9.80294L10.9102 10.0682Z",
    fill: "url(#paint0_linear_821_34938)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1704 12.7406C23.3829 12.3054 23.4942 11.8197 23.4942 11.3137C23.4942 10.8464 23.3981 10.4079 23.2257 10.0082H23.231C23.1505 9.82721 23.0601 9.65621 22.9498 9.49521L22.9477 9.49208C22.6036 8.96584 22.4215 8.34852 22.4215 7.72107V7.71095C22.4215 5.88935 20.944 4.41182 19.1224 4.41182C18.9402 4.41182 18.7682 4.33086 18.667 4.17906C18.0699 3.34922 17.0881 2.80273 15.985 2.80273C14.882 2.80273 13.9003 3.34922 13.3032 4.17906C13.202 4.32074 13.03 4.41182 12.8478 4.41182C12.8194 4.41182 12.7911 4.41218 12.7628 4.4129C10.9805 4.45802 9.54869 5.91777 9.54869 7.71095V7.72107C9.54869 8.34852 9.36653 8.96584 9.02245 9.49208L9.02016 9.49575C8.67753 10.0212 8.47607 10.6372 8.47607 11.3137C8.47607 11.8298 8.59751 12.3054 8.79992 12.7406C8.87076 12.8823 8.87076 13.0543 8.79992 13.196C8.59751 13.6211 8.47607 14.0967 8.47607 14.6027C8.47607 16.3838 9.91312 17.8209 11.6942 17.8209H20.276C22.0572 17.8209 23.4942 16.3838 23.4942 14.6027C23.4942 14.0967 23.3728 13.6211 23.1704 13.196C23.0995 13.0543 23.0995 12.8823 23.1704 12.7406ZM10.9102 10.0682H10.8979L12.0966 12.4237C12.2199 15.2263 13.3136 12.4237 15.985 12.4237C18.6565 12.4237 19.8214 15.5431 19.9447 12.7406L21.0806 9.54348C21.0269 8.29864 20.1248 8.21127 19.9447 8.21127H16.7247C15.4531 8.21127 14.2533 7.58889 13.5354 6.53798C13.4124 6.36453 13.156 6.39514 13.074 6.58899L12.9919 6.78285C12.7663 7.34402 12.3356 7.77254 11.8024 8.01741C11.787 8.02252 11.7691 8.03017 11.7511 8.03782C11.7332 8.04547 11.7152 8.05312 11.6998 8.05823C11.464 8.18066 10.9102 8.54797 10.8897 9.49685L10.9 9.80294L10.9102 10.0682Z",
    fill: "url(#paint1_radial_821_34938)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1704 12.7406C23.3829 12.3054 23.4942 11.8197 23.4942 11.3137C23.4942 10.8464 23.3981 10.4079 23.2257 10.0082H23.231C23.1505 9.82721 23.0601 9.65621 22.9498 9.49521L22.9477 9.49208C22.6036 8.96584 22.4215 8.34852 22.4215 7.72107V7.71095C22.4215 5.88935 20.944 4.41182 19.1224 4.41182C18.9402 4.41182 18.7682 4.33086 18.667 4.17906C18.0699 3.34922 17.0881 2.80273 15.985 2.80273C14.882 2.80273 13.9003 3.34922 13.3032 4.17906C13.202 4.32074 13.03 4.41182 12.8478 4.41182C12.8194 4.41182 12.7911 4.41218 12.7628 4.4129C10.9805 4.45802 9.54869 5.91777 9.54869 7.71095V7.72107C9.54869 8.34852 9.36653 8.96584 9.02245 9.49208L9.02016 9.49575C8.67753 10.0212 8.47607 10.6372 8.47607 11.3137C8.47607 11.8298 8.59751 12.3054 8.79992 12.7406C8.87076 12.8823 8.87076 13.0543 8.79992 13.196C8.59751 13.6211 8.47607 14.0967 8.47607 14.6027C8.47607 16.3838 9.91312 17.8209 11.6942 17.8209H20.276C22.0572 17.8209 23.4942 16.3838 23.4942 14.6027C23.4942 14.0967 23.3728 13.6211 23.1704 13.196C23.0995 13.0543 23.0995 12.8823 23.1704 12.7406ZM10.9102 10.0682H10.8979L12.0966 12.4237C12.2199 15.2263 13.3136 12.4237 15.985 12.4237C18.6565 12.4237 19.8214 15.5431 19.9447 12.7406L21.0806 9.54348C21.0269 8.29864 20.1248 8.21127 19.9447 8.21127H16.7247C15.4531 8.21127 14.2533 7.58889 13.5354 6.53798C13.4124 6.36453 13.156 6.39514 13.074 6.58899L12.9919 6.78285C12.7663 7.34402 12.3356 7.77254 11.8024 8.01741C11.787 8.02252 11.7691 8.03017 11.7511 8.03782C11.7332 8.04547 11.7152 8.05312 11.6998 8.05823C11.464 8.18066 10.9102 8.54797 10.8897 9.49685L10.9 9.80294L10.9102 10.0682Z",
    fill: "url(#paint2_radial_821_34938)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1704 12.7406C23.3829 12.3054 23.4942 11.8197 23.4942 11.3137C23.4942 10.8464 23.3981 10.4079 23.2257 10.0082H23.231C23.1505 9.82721 23.0601 9.65621 22.9498 9.49521L22.9477 9.49208C22.6036 8.96584 22.4215 8.34852 22.4215 7.72107V7.71095C22.4215 5.88935 20.944 4.41182 19.1224 4.41182C18.9402 4.41182 18.7682 4.33086 18.667 4.17906C18.0699 3.34922 17.0881 2.80273 15.985 2.80273C14.882 2.80273 13.9003 3.34922 13.3032 4.17906C13.202 4.32074 13.03 4.41182 12.8478 4.41182C12.8194 4.41182 12.7911 4.41218 12.7628 4.4129C10.9805 4.45802 9.54869 5.91777 9.54869 7.71095V7.72107C9.54869 8.34852 9.36653 8.96584 9.02245 9.49208L9.02016 9.49575C8.67753 10.0212 8.47607 10.6372 8.47607 11.3137C8.47607 11.8298 8.59751 12.3054 8.79992 12.7406C8.87076 12.8823 8.87076 13.0543 8.79992 13.196C8.59751 13.6211 8.47607 14.0967 8.47607 14.6027C8.47607 16.3838 9.91312 17.8209 11.6942 17.8209H20.276C22.0572 17.8209 23.4942 16.3838 23.4942 14.6027C23.4942 14.0967 23.3728 13.6211 23.1704 13.196C23.0995 13.0543 23.0995 12.8823 23.1704 12.7406ZM10.9102 10.0682H10.8979L12.0966 12.4237C12.2199 15.2263 13.3136 12.4237 15.985 12.4237C18.6565 12.4237 19.8214 15.5431 19.9447 12.7406L21.0806 9.54348C21.0269 8.29864 20.1248 8.21127 19.9447 8.21127H16.7247C15.4531 8.21127 14.2533 7.58889 13.5354 6.53798C13.4124 6.36453 13.156 6.39514 13.074 6.58899L12.9919 6.78285C12.7663 7.34402 12.3356 7.77254 11.8024 8.01741C11.787 8.02252 11.7691 8.03017 11.7511 8.03782C11.7332 8.04547 11.7152 8.05312 11.6998 8.05823C11.464 8.18066 10.9102 8.54797 10.8897 9.49685L10.9 9.80294L10.9102 10.0682Z",
    fill: "url(#paint3_radial_821_34938)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1704 12.7406C23.3829 12.3054 23.4942 11.8197 23.4942 11.3137C23.4942 10.8464 23.3981 10.4079 23.2257 10.0082H23.231C23.1505 9.82721 23.0601 9.65621 22.9498 9.49521L22.9477 9.49208C22.6036 8.96584 22.4215 8.34852 22.4215 7.72107V7.71095C22.4215 5.88935 20.944 4.41182 19.1224 4.41182C18.9402 4.41182 18.7682 4.33086 18.667 4.17906C18.0699 3.34922 17.0881 2.80273 15.985 2.80273C14.882 2.80273 13.9003 3.34922 13.3032 4.17906C13.202 4.32074 13.03 4.41182 12.8478 4.41182C12.8194 4.41182 12.7911 4.41218 12.7628 4.4129C10.9805 4.45802 9.54869 5.91777 9.54869 7.71095V7.72107C9.54869 8.34852 9.36653 8.96584 9.02245 9.49208L9.02016 9.49575C8.67753 10.0212 8.47607 10.6372 8.47607 11.3137C8.47607 11.8298 8.59751 12.3054 8.79992 12.7406C8.87076 12.8823 8.87076 13.0543 8.79992 13.196C8.59751 13.6211 8.47607 14.0967 8.47607 14.6027C8.47607 16.3838 9.91312 17.8209 11.6942 17.8209H20.276C22.0572 17.8209 23.4942 16.3838 23.4942 14.6027C23.4942 14.0967 23.3728 13.6211 23.1704 13.196C23.0995 13.0543 23.0995 12.8823 23.1704 12.7406ZM10.9102 10.0682H10.8979L12.0966 12.4237C12.2199 15.2263 13.3136 12.4237 15.985 12.4237C18.6565 12.4237 19.8214 15.5431 19.9447 12.7406L21.0806 9.54348C21.0269 8.29864 20.1248 8.21127 19.9447 8.21127H16.7247C15.4531 8.21127 14.2533 7.58889 13.5354 6.53798C13.4124 6.36453 13.156 6.39514 13.074 6.58899L12.9919 6.78285C12.7663 7.34402 12.3356 7.77254 11.8024 8.01741C11.787 8.02252 11.7691 8.03017 11.7511 8.03782C11.7332 8.04547 11.7152 8.05312 11.6998 8.05823C11.464 8.18066 10.9102 8.54797 10.8897 9.49685L10.9 9.80294L10.9102 10.0682Z",
    fill: "url(#paint4_radial_821_34938)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1704 12.7406C23.3829 12.3054 23.4942 11.8197 23.4942 11.3137C23.4942 10.8464 23.3981 10.4079 23.2257 10.0082H23.231C23.1505 9.82721 23.0601 9.65621 22.9498 9.49521L22.9477 9.49208C22.6036 8.96584 22.4215 8.34852 22.4215 7.72107V7.71095C22.4215 5.88935 20.944 4.41182 19.1224 4.41182C18.9402 4.41182 18.7682 4.33086 18.667 4.17906C18.0699 3.34922 17.0881 2.80273 15.985 2.80273C14.882 2.80273 13.9003 3.34922 13.3032 4.17906C13.202 4.32074 13.03 4.41182 12.8478 4.41182C12.8194 4.41182 12.7911 4.41218 12.7628 4.4129C10.9805 4.45802 9.54869 5.91777 9.54869 7.71095V7.72107C9.54869 8.34852 9.36653 8.96584 9.02245 9.49208L9.02016 9.49575C8.67753 10.0212 8.47607 10.6372 8.47607 11.3137C8.47607 11.8298 8.59751 12.3054 8.79992 12.7406C8.87076 12.8823 8.87076 13.0543 8.79992 13.196C8.59751 13.6211 8.47607 14.0967 8.47607 14.6027C8.47607 16.3838 9.91312 17.8209 11.6942 17.8209H20.276C22.0572 17.8209 23.4942 16.3838 23.4942 14.6027C23.4942 14.0967 23.3728 13.6211 23.1704 13.196C23.0995 13.0543 23.0995 12.8823 23.1704 12.7406ZM10.9102 10.0682H10.8979L12.0966 12.4237C12.2199 15.2263 13.3136 12.4237 15.985 12.4237C18.6565 12.4237 19.8214 15.5431 19.9447 12.7406L21.0806 9.54348C21.0269 8.29864 20.1248 8.21127 19.9447 8.21127H16.7247C15.4531 8.21127 14.2533 7.58889 13.5354 6.53798C13.4124 6.36453 13.156 6.39514 13.074 6.58899L12.9919 6.78285C12.7663 7.34402 12.3356 7.77254 11.8024 8.01741C11.787 8.02252 11.7691 8.03017 11.7511 8.03782C11.7332 8.04547 11.7152 8.05312 11.6998 8.05823C11.464 8.18066 10.9102 8.54797 10.8897 9.49685L10.9 9.80294L10.9102 10.0682Z",
    fill: "url(#paint5_radial_821_34938)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1704 12.7406C23.3829 12.3054 23.4942 11.8197 23.4942 11.3137C23.4942 10.8464 23.3981 10.4079 23.2257 10.0082H23.231C23.1505 9.82721 23.0601 9.65621 22.9498 9.49521L22.9477 9.49208C22.6036 8.96584 22.4215 8.34852 22.4215 7.72107V7.71095C22.4215 5.88935 20.944 4.41182 19.1224 4.41182C18.9402 4.41182 18.7682 4.33086 18.667 4.17906C18.0699 3.34922 17.0881 2.80273 15.985 2.80273C14.882 2.80273 13.9003 3.34922 13.3032 4.17906C13.202 4.32074 13.03 4.41182 12.8478 4.41182C12.8194 4.41182 12.7911 4.41218 12.7628 4.4129C10.9805 4.45802 9.54869 5.91777 9.54869 7.71095V7.72107C9.54869 8.34852 9.36653 8.96584 9.02245 9.49208L9.02016 9.49575C8.67753 10.0212 8.47607 10.6372 8.47607 11.3137C8.47607 11.8298 8.59751 12.3054 8.79992 12.7406C8.87076 12.8823 8.87076 13.0543 8.79992 13.196C8.59751 13.6211 8.47607 14.0967 8.47607 14.6027C8.47607 16.3838 9.91312 17.8209 11.6942 17.8209H20.276C22.0572 17.8209 23.4942 16.3838 23.4942 14.6027C23.4942 14.0967 23.3728 13.6211 23.1704 13.196C23.0995 13.0543 23.0995 12.8823 23.1704 12.7406ZM10.9102 10.0682H10.8979L12.0966 12.4237C12.2199 15.2263 13.3136 12.4237 15.985 12.4237C18.6565 12.4237 19.8214 15.5431 19.9447 12.7406L21.0806 9.54348C21.0269 8.29864 20.1248 8.21127 19.9447 8.21127H16.7247C15.4531 8.21127 14.2533 7.58889 13.5354 6.53798C13.4124 6.36453 13.156 6.39514 13.074 6.58899L12.9919 6.78285C12.7663 7.34402 12.3356 7.77254 11.8024 8.01741C11.787 8.02252 11.7691 8.03017 11.7511 8.03782C11.7332 8.04547 11.7152 8.05312 11.6998 8.05823C11.464 8.18066 10.9102 8.54797 10.8897 9.49685L10.9 9.80294L10.9102 10.0682Z",
    fill: "url(#paint6_radial_821_34938)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1704 12.7406C23.3829 12.3054 23.4942 11.8197 23.4942 11.3137C23.4942 10.8464 23.3981 10.4079 23.2257 10.0082H23.231C23.1505 9.82721 23.0601 9.65621 22.9498 9.49521L22.9477 9.49208C22.6036 8.96584 22.4215 8.34852 22.4215 7.72107V7.71095C22.4215 5.88935 20.944 4.41182 19.1224 4.41182C18.9402 4.41182 18.7682 4.33086 18.667 4.17906C18.0699 3.34922 17.0881 2.80273 15.985 2.80273C14.882 2.80273 13.9003 3.34922 13.3032 4.17906C13.202 4.32074 13.03 4.41182 12.8478 4.41182C12.8194 4.41182 12.7911 4.41218 12.7628 4.4129C10.9805 4.45802 9.54869 5.91777 9.54869 7.71095V7.72107C9.54869 8.34852 9.36653 8.96584 9.02245 9.49208L9.02016 9.49575C8.67753 10.0212 8.47607 10.6372 8.47607 11.3137C8.47607 11.8298 8.59751 12.3054 8.79992 12.7406C8.87076 12.8823 8.87076 13.0543 8.79992 13.196C8.59751 13.6211 8.47607 14.0967 8.47607 14.6027C8.47607 16.3838 9.91312 17.8209 11.6942 17.8209H20.276C22.0572 17.8209 23.4942 16.3838 23.4942 14.6027C23.4942 14.0967 23.3728 13.6211 23.1704 13.196C23.0995 13.0543 23.0995 12.8823 23.1704 12.7406ZM10.9102 10.0682H10.8979L12.0966 12.4237C12.2199 15.2263 13.3136 12.4237 15.985 12.4237C18.6565 12.4237 19.8214 15.5431 19.9447 12.7406L21.0806 9.54348C21.0269 8.29864 20.1248 8.21127 19.9447 8.21127H16.7247C15.4531 8.21127 14.2533 7.58889 13.5354 6.53798C13.4124 6.36453 13.156 6.39514 13.074 6.58899L12.9919 6.78285C12.7663 7.34402 12.3356 7.77254 11.8024 8.01741C11.787 8.02252 11.7691 8.03017 11.7511 8.03782C11.7332 8.04547 11.7152 8.05312 11.6998 8.05823C11.464 8.18066 10.9102 8.54797 10.8897 9.49685L10.9 9.80294L10.9102 10.0682Z",
    fill: "url(#paint7_radial_821_34938)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1704 12.7406C23.3829 12.3054 23.4942 11.8197 23.4942 11.3137C23.4942 10.8464 23.3981 10.4079 23.2257 10.0082H23.231C23.1505 9.82721 23.0601 9.65621 22.9498 9.49521L22.9477 9.49208C22.6036 8.96584 22.4215 8.34852 22.4215 7.72107V7.71095C22.4215 5.88935 20.944 4.41182 19.1224 4.41182C18.9402 4.41182 18.7682 4.33086 18.667 4.17906C18.0699 3.34922 17.0881 2.80273 15.985 2.80273C14.882 2.80273 13.9003 3.34922 13.3032 4.17906C13.202 4.32074 13.03 4.41182 12.8478 4.41182C12.8194 4.41182 12.7911 4.41218 12.7628 4.4129C10.9805 4.45802 9.54869 5.91777 9.54869 7.71095V7.72107C9.54869 8.34852 9.36653 8.96584 9.02245 9.49208L9.02016 9.49575C8.67753 10.0212 8.47607 10.6372 8.47607 11.3137C8.47607 11.8298 8.59751 12.3054 8.79992 12.7406C8.87076 12.8823 8.87076 13.0543 8.79992 13.196C8.59751 13.6211 8.47607 14.0967 8.47607 14.6027C8.47607 16.3838 9.91312 17.8209 11.6942 17.8209H20.276C22.0572 17.8209 23.4942 16.3838 23.4942 14.6027C23.4942 14.0967 23.3728 13.6211 23.1704 13.196C23.0995 13.0543 23.0995 12.8823 23.1704 12.7406ZM10.9102 10.0682H10.8979L12.0966 12.4237C12.2199 15.2263 13.3136 12.4237 15.985 12.4237C18.6565 12.4237 19.8214 15.5431 19.9447 12.7406L21.0806 9.54348C21.0269 8.29864 20.1248 8.21127 19.9447 8.21127H16.7247C15.4531 8.21127 14.2533 7.58889 13.5354 6.53798C13.4124 6.36453 13.156 6.39514 13.074 6.58899L12.9919 6.78285C12.7663 7.34402 12.3356 7.77254 11.8024 8.01741C11.787 8.02252 11.7691 8.03017 11.7511 8.03782C11.7332 8.04547 11.7152 8.05312 11.6998 8.05823C11.464 8.18066 10.9102 8.54797 10.8897 9.49685L10.9 9.80294L10.9102 10.0682Z",
    fill: "url(#paint8_radial_821_34938)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1704 12.7406C23.3829 12.3054 23.4942 11.8197 23.4942 11.3137C23.4942 10.8464 23.3981 10.4079 23.2257 10.0082H23.231C23.1505 9.82721 23.0601 9.65621 22.9498 9.49521L22.9477 9.49208C22.6036 8.96584 22.4215 8.34852 22.4215 7.72107V7.71095C22.4215 5.88935 20.944 4.41182 19.1224 4.41182C18.9402 4.41182 18.7682 4.33086 18.667 4.17906C18.0699 3.34922 17.0881 2.80273 15.985 2.80273C14.882 2.80273 13.9003 3.34922 13.3032 4.17906C13.202 4.32074 13.03 4.41182 12.8478 4.41182C12.8194 4.41182 12.7911 4.41218 12.7628 4.4129C10.9805 4.45802 9.54869 5.91777 9.54869 7.71095V7.72107C9.54869 8.34852 9.36653 8.96584 9.02245 9.49208L9.02016 9.49575C8.67753 10.0212 8.47607 10.6372 8.47607 11.3137C8.47607 11.8298 8.59751 12.3054 8.79992 12.7406C8.87076 12.8823 8.87076 13.0543 8.79992 13.196C8.59751 13.6211 8.47607 14.0967 8.47607 14.6027C8.47607 16.3838 9.91312 17.8209 11.6942 17.8209H20.276C22.0572 17.8209 23.4942 16.3838 23.4942 14.6027C23.4942 14.0967 23.3728 13.6211 23.1704 13.196C23.0995 13.0543 23.0995 12.8823 23.1704 12.7406ZM10.9102 10.0682H10.8979L12.0966 12.4237C12.2199 15.2263 13.3136 12.4237 15.985 12.4237C18.6565 12.4237 19.8214 15.5431 19.9447 12.7406L21.0806 9.54348C21.0269 8.29864 20.1248 8.21127 19.9447 8.21127H16.7247C15.4531 8.21127 14.2533 7.58889 13.5354 6.53798C13.4124 6.36453 13.156 6.39514 13.074 6.58899L12.9919 6.78285C12.7663 7.34402 12.3356 7.77254 11.8024 8.01741C11.787 8.02252 11.7691 8.03017 11.7511 8.03782C11.7332 8.04547 11.7152 8.05312 11.6998 8.05823C11.464 8.18066 10.9102 8.54797 10.8897 9.49685L10.9 9.80294L10.9102 10.0682Z",
    fill: "url(#paint9_radial_821_34938)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_821_34938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 15.4675C9.92 15.4675 5 20.3875 5 26.4675V29.9675H27V26.4675C27 20.3975 22.07 15.4675 16 15.4675Z",
    fill: "url(#paint10_linear_821_34938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 15.4675C9.92 15.4675 5 20.3875 5 26.4675V29.9675H27V26.4675C27 20.3975 22.07 15.4675 16 15.4675Z",
    fill: "url(#paint11_radial_821_34938)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_821_34938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4187 16.8162C12.9063 16.8162 12.1232 16.787 11.6488 16.9824L10.2687 19.7062C10.1787 19.8962 10.3287 20.1162 10.5387 20.1162H12.0887C12.3287 20.1162 12.4387 20.4062 12.2787 20.5662L10.4987 21.9091C10.2387 22.1691 10.1387 22.5591 10.2687 22.9091L13.1815 29.4096L14.7677 28.2933L13.4287 16.8162H13.4187Z",
    fill: "#46375F"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_821_34938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9045 21.1489L19.7154 20.3209C19.5668 20.1723 19.6717 19.9275 19.8815 19.9275H20.7996C20.9832 19.9275 21.1056 19.7351 21.0269 19.569L19.9515 17.2783C19.7416 17.1909 19.5231 17.1122 19.3045 17.0422H18.71V28.904L21.1143 22.0319C21.2192 21.7172 21.1405 21.3762 20.9045 21.1489Z",
    fill: "#493E6A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.71 16.0874H13.29V29.9774H18.71V16.0874Z",
    fill: "url(#paint12_radial_821_34938)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.71 16.0874H13.29V29.9774H18.71V16.0874Z",
    fill: "url(#paint13_linear_821_34938)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.71 16.0874H13.29V29.9774H18.71V16.0874Z",
    fill: "url(#paint14_linear_821_34938)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 17.9851V29.9674H27V26.4674C27 23.0554 25.4423 20.0036 23 17.9851Z",
    fill: "url(#paint15_radial_821_34938)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23 17.9851V29.9674H27V26.4674C27 23.0554 25.4423 20.0036 23 17.9851Z",
    fill: "url(#paint16_linear_821_34938)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_821_34938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2897 16.0574H12.4397C12.2597 16.1174 12.0797 16.1874 11.9097 16.2574L10.6397 18.9474C10.5497 19.1374 10.6997 19.3574 10.9097 19.3574H11.9597C12.1997 19.3574 12.3097 19.6474 12.1497 19.8074L10.7897 21.1374C10.5297 21.3974 10.4297 21.7874 10.5597 22.1374L13.2897 29.9574H13.2997V16.0574H13.2897Z",
    fill: "url(#paint17_linear_821_34938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2897 16.0574H12.4397C12.2597 16.1174 12.0797 16.1874 11.9097 16.2574L10.6397 18.9474C10.5497 19.1374 10.6997 19.3574 10.9097 19.3574H11.9597C12.1997 19.3574 12.3097 19.6474 12.1497 19.8074L10.7897 21.1374C10.5297 21.3974 10.4297 21.7874 10.5597 22.1374L13.2897 29.9574H13.2997V16.0574H13.2897Z",
    fill: "url(#paint18_linear_821_34938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2897 16.0574H12.4397C12.2597 16.1174 12.0797 16.1874 11.9097 16.2574L10.6397 18.9474C10.5497 19.1374 10.6997 19.3574 10.9097 19.3574H11.9597C12.1997 19.3574 12.3097 19.6474 12.1497 19.8074L10.7897 21.1374C10.5297 21.3974 10.4297 21.7874 10.5597 22.1374L13.2897 29.9574H13.2997V16.0574H13.2897Z",
    fill: "url(#paint19_radial_821_34938)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2897 16.0574H12.4397C12.2597 16.1174 12.0797 16.1874 11.9097 16.2574L10.6397 18.9474C10.5497 19.1374 10.6997 19.3574 10.9097 19.3574H11.9597C12.1997 19.3574 12.3097 19.6474 12.1497 19.8074L10.7897 21.1374C10.5297 21.3974 10.4297 21.7874 10.5597 22.1374L13.2897 29.9574H13.2997V16.0574H13.2897Z",
    fill: "url(#paint20_linear_821_34938)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2897 16.0574H12.4397C12.2597 16.1174 12.0797 16.1874 11.9097 16.2574L10.6397 18.9474C10.5497 19.1374 10.6997 19.3574 10.9097 19.3574H11.9597C12.1997 19.3574 12.3097 19.6474 12.1497 19.8074L10.7897 21.1374C10.5297 21.3974 10.4297 21.7874 10.5597 22.1374L13.2897 29.9574H13.2997V16.0574H13.2897Z",
    fill: "url(#paint21_radial_821_34938)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2897 16.0574H12.4397C12.2597 16.1174 12.0797 16.1874 11.9097 16.2574L10.6397 18.9474C10.5497 19.1374 10.6997 19.3574 10.9097 19.3574H11.9597C12.1997 19.3574 12.3097 19.6474 12.1497 19.8074L10.7897 21.1374C10.5297 21.3974 10.4297 21.7874 10.5597 22.1374L13.2897 29.9574H13.2997V16.0574H13.2897Z",
    fill: "url(#paint22_linear_821_34938)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ii_821_34938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0127 18.2947L14.6565 19.5698C14.6083 19.6152 14.5955 19.6868 14.6251 19.7461L15.2212 20.9392C15.2636 21.0239 15.3501 21.0775 15.4449 21.0775H16.535C16.6301 21.0775 16.717 21.0235 16.7591 20.9382L17.3584 19.7255C17.3875 19.6667 17.375 19.5959 17.3275 19.5506L16.0127 18.2947Z",
    fill: "url(#paint23_linear_821_34938)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_821_34938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.22 21.0876L19.86 19.7576C19.69 19.5876 19.81 19.3076 20.05 19.3076H21.1C21.31 19.3076 21.45 19.0876 21.36 18.8976L20.13 16.2776C19.89 16.1776 19.64 16.0876 19.39 16.0076H18.71V29.9576L21.46 22.0976C21.58 21.7376 21.49 21.3476 21.22 21.0876Z",
    fill: "#615990"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.22 21.0876L19.86 19.7576C19.69 19.5876 19.81 19.3076 20.05 19.3076H21.1C21.31 19.3076 21.45 19.0876 21.36 18.8976L20.13 16.2776C19.89 16.1776 19.64 16.0876 19.39 16.0076H18.71V29.9576L21.46 22.0976C21.58 21.7376 21.49 21.3476 21.22 21.0876Z",
    fill: "url(#paint24_linear_821_34938)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.0244H13.29V19.7644C13.29 20.0744 13.65 20.2544 13.9 20.0544L16 18.6619L18.1 20.0544C18.35 20.2544 18.71 20.0744 18.71 19.7644V15.0244H16Z",
    fill: "url(#paint25_radial_821_34938)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.0244H13.29V19.7644C13.29 20.0744 13.65 20.2544 13.9 20.0544L16 18.6619L18.1 20.0544C18.35 20.2544 18.71 20.0744 18.71 19.7644V15.0244H16Z",
    fill: "url(#paint26_radial_821_34938)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03187 29.9676H8.9701V18.0034C7.18742 19.4852 5.88126 21.5201 5.31367 23.8461C5.11021 24.69 5.00465 25.5714 5.00996 26.4776L5.02992 29.9676H7.03187Z",
    fill: "url(#paint27_linear_821_34938)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5048 21.0774C15.3813 21.0774 15.2764 21.1675 15.2577 21.2895L13.9302 29.9574H18.0402L16.7225 21.2898C16.7039 21.1677 16.5989 21.0774 16.4753 21.0774H15.5048Z",
    fill: "url(#paint28_radial_821_34938)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5048 21.0774C15.3813 21.0774 15.2764 21.1675 15.2577 21.2895L13.9302 29.9574H18.0402L16.7225 21.2898C16.7039 21.1677 16.5989 21.0774 16.4753 21.0774H15.5048Z",
    fill: "url(#paint29_linear_821_34938)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5048 21.0774C15.3813 21.0774 15.2764 21.1675 15.2577 21.2895L13.9302 29.9574H18.0402L16.7225 21.2898C16.7039 21.1677 16.5989 21.0774 16.4753 21.0774H15.5048Z",
    fill: "url(#paint30_linear_821_34938)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0449 16.8572C14.0658 17.0707 14.2499 17.5482 14.791 17.9119C15.0045 18.0553 16.0041 18.5405 15.9837 18.5307C16.1399 18.4526 16.791 18.2322 17.2676 17.9119C17.8087 17.5482 17.9928 17.0707 18.0137 16.8572L16.0293 15.9041L14.0449 16.8572Z",
    fill: "url(#paint31_radial_821_34938)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_821_34938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2995 12.9399C12.1882 12.9399 12.9086 12.2194 12.9086 11.3308C12.9086 10.4421 12.1882 9.72168 11.2995 9.72168C10.4108 9.72168 9.69043 10.4421 9.69043 11.3308C9.69043 12.2194 10.4108 12.9399 11.2995 12.9399Z",
    fill: "url(#paint32_linear_821_34938)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_821_34938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8122 12.9399C21.7009 12.9399 22.4213 12.2194 22.4213 11.3308C22.4213 10.4421 21.7009 9.72168 20.8122 9.72168C19.9235 9.72168 19.2031 10.4421 19.2031 11.3308C19.2031 12.2194 19.9235 12.9399 20.8122 12.9399Z",
    fill: "url(#paint33_radial_821_34938)"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_821_34938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8124 12.4048C21.4056 12.4048 21.8865 11.9239 21.8865 11.3307C21.8865 10.7375 21.4056 10.2566 20.8124 10.2566C20.2192 10.2566 19.7383 10.7375 19.7383 11.3307C19.7383 11.9239 20.2192 12.4048 20.8124 12.4048Z",
    fill: "#FFCA38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8124 12.4048C21.4056 12.4048 21.8865 11.9239 21.8865 11.3307C21.8865 10.7375 21.4056 10.2566 20.8124 10.2566C20.2192 10.2566 19.7383 10.7375 19.7383 11.3307C19.7383 11.9239 20.2192 12.4048 20.8124 12.4048Z",
    fill: "url(#paint34_radial_821_34938)"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_821_34938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3187 12.4048C11.912 12.4048 12.3928 11.9239 12.3928 11.3307C12.3928 10.7375 11.912 10.2566 11.3187 10.2566C10.7255 10.2566 10.2446 10.7375 10.2446 11.3307C10.2446 11.9239 10.7255 12.4048 11.3187 12.4048Z",
    fill: "#E28527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3187 12.4048C11.912 12.4048 12.3928 11.9239 12.3928 11.3307C12.3928 10.7375 11.912 10.2566 11.3187 10.2566C10.7255 10.2566 10.2446 10.7375 10.2446 11.3307C10.2446 11.9239 10.7255 12.4048 11.3187 12.4048Z",
    fill: "url(#paint35_radial_821_34938)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_i_821_34938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8978 10.0682H10.9102L10.8999 9.80296L10.8896 9.49687C10.9102 8.54799 11.4639 8.18068 11.6998 8.05824C11.7152 8.05314 11.7331 8.04549 11.7511 8.03784C11.769 8.03019 11.7869 8.02253 11.8023 8.01743C12.3356 7.77256 12.7663 7.34404 12.9919 6.78287L13.0739 6.58901C13.156 6.39516 13.4123 6.36455 13.5354 6.538C14.2532 7.58891 15.453 8.21129 16.7246 8.21129H19.9447C20.1247 8.21129 21.0268 8.29866 21.0805 9.5435L20.9618 12.6165C20.8385 15.419 18.65 17.3009 15.9785 17.3009C13.3071 17.3009 11.1186 15.419 10.9953 12.6165L10.8978 10.0682Z",
    fill: "url(#paint36_radial_821_34938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8978 10.0682H10.9102L10.8999 9.80296L10.8896 9.49687C10.9102 8.54799 11.4639 8.18068 11.6998 8.05824C11.7152 8.05314 11.7331 8.04549 11.7511 8.03784C11.769 8.03019 11.7869 8.02253 11.8023 8.01743C12.3356 7.77256 12.7663 7.34404 12.9919 6.78287L13.0739 6.58901C13.156 6.39516 13.4123 6.36455 13.5354 6.538C14.2532 7.58891 15.453 8.21129 16.7246 8.21129H19.9447C20.1247 8.21129 21.0268 8.29866 21.0805 9.5435L20.9618 12.6165C20.8385 15.419 18.65 17.3009 15.9785 17.3009C13.3071 17.3009 11.1186 15.419 10.9953 12.6165L10.8978 10.0682Z",
    fill: "url(#paint37_radial_821_34938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8978 10.0682H10.9102L10.8999 9.80296L10.8896 9.49687C10.9102 8.54799 11.4639 8.18068 11.6998 8.05824C11.7152 8.05314 11.7331 8.04549 11.7511 8.03784C11.769 8.03019 11.7869 8.02253 11.8023 8.01743C12.3356 7.77256 12.7663 7.34404 12.9919 6.78287L13.0739 6.58901C13.156 6.39516 13.4123 6.36455 13.5354 6.538C14.2532 7.58891 15.453 8.21129 16.7246 8.21129H19.9447C20.1247 8.21129 21.0268 8.29866 21.0805 9.5435L20.9618 12.6165C20.8385 15.419 18.65 17.3009 15.9785 17.3009C13.3071 17.3009 11.1186 15.419 10.9953 12.6165L10.8978 10.0682Z",
    fill: "url(#paint38_radial_821_34938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8978 10.0682H10.9102L10.8999 9.80296L10.8896 9.49687C10.9102 8.54799 11.4639 8.18068 11.6998 8.05824C11.7152 8.05314 11.7331 8.04549 11.7511 8.03784C11.769 8.03019 11.7869 8.02253 11.8023 8.01743C12.3356 7.77256 12.7663 7.34404 12.9919 6.78287L13.0739 6.58901C13.156 6.39516 13.4123 6.36455 13.5354 6.538C14.2532 7.58891 15.453 8.21129 16.7246 8.21129H19.9447C20.1247 8.21129 21.0268 8.29866 21.0805 9.5435L20.9618 12.6165C20.8385 15.419 18.65 17.3009 15.9785 17.3009C13.3071 17.3009 11.1186 15.419 10.9953 12.6165L10.8978 10.0682Z",
    fill: "url(#paint39_radial_821_34938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8978 10.0682H10.9102L10.8999 9.80296L10.8896 9.49687C10.9102 8.54799 11.4639 8.18068 11.6998 8.05824C11.7152 8.05314 11.7331 8.04549 11.7511 8.03784C11.769 8.03019 11.7869 8.02253 11.8023 8.01743C12.3356 7.77256 12.7663 7.34404 12.9919 6.78287L13.0739 6.58901C13.156 6.39516 13.4123 6.36455 13.5354 6.538C14.2532 7.58891 15.453 8.21129 16.7246 8.21129H19.9447C20.1247 8.21129 21.0268 8.29866 21.0805 9.5435L20.9618 12.6165C20.8385 15.419 18.65 17.3009 15.9785 17.3009C13.3071 17.3009 11.1186 15.419 10.9953 12.6165L10.8978 10.0682Z",
    fill: "url(#paint40_radial_821_34938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8978 10.0682H10.9102L10.8999 9.80296L10.8896 9.49687C10.9102 8.54799 11.4639 8.18068 11.6998 8.05824C11.7152 8.05314 11.7331 8.04549 11.7511 8.03784C11.769 8.03019 11.7869 8.02253 11.8023 8.01743C12.3356 7.77256 12.7663 7.34404 12.9919 6.78287L13.0739 6.58901C13.156 6.39516 13.4123 6.36455 13.5354 6.538C14.2532 7.58891 15.453 8.21129 16.7246 8.21129H19.9447C20.1247 8.21129 21.0268 8.29866 21.0805 9.5435L20.9618 12.6165C20.8385 15.419 18.65 17.3009 15.9785 17.3009C13.3071 17.3009 11.1186 15.419 10.9953 12.6165L10.8978 10.0682Z",
    fill: "url(#paint41_radial_821_34938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8978 10.0682H10.9102L10.8999 9.80296L10.8896 9.49687C10.9102 8.54799 11.4639 8.18068 11.6998 8.05824C11.7152 8.05314 11.7331 8.04549 11.7511 8.03784C11.769 8.03019 11.7869 8.02253 11.8023 8.01743C12.3356 7.77256 12.7663 7.34404 12.9919 6.78287L13.0739 6.58901C13.156 6.39516 13.4123 6.36455 13.5354 6.538C14.2532 7.58891 15.453 8.21129 16.7246 8.21129H19.9447C20.1247 8.21129 21.0268 8.29866 21.0805 9.5435L20.9618 12.6165C20.8385 15.419 18.65 17.3009 15.9785 17.3009C13.3071 17.3009 11.1186 15.419 10.9953 12.6165L10.8978 10.0682Z",
    fill: "url(#paint42_radial_821_34938)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8978 10.0682H10.9102L10.8999 9.80296L10.8896 9.49687C10.9102 8.54799 11.4639 8.18068 11.6998 8.05824C11.7152 8.05314 11.7331 8.04549 11.7511 8.03784C11.769 8.03019 11.7869 8.02253 11.8023 8.01743C12.3356 7.77256 12.7663 7.34404 12.9919 6.78287L13.0739 6.58901C13.156 6.39516 13.4123 6.36455 13.5354 6.538C14.2532 7.58891 15.453 8.21129 16.7246 8.21129H19.9447C20.1247 8.21129 21.0268 8.29866 21.0805 9.5435L20.9618 12.6165C20.8385 15.419 18.65 17.3009 15.9785 17.3009C13.3071 17.3009 11.1186 15.419 10.9953 12.6165L10.8978 10.0682Z",
    fill: "url(#paint43_radial_821_34938)"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_821_34938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5922 11.1081L14.9086 12.8081C14.8002 13.1578 15.0605 13.5075 15.4292 13.5075H16.2156C16.5844 13.5075 16.8447 13.1524 16.7362 12.8081L16.2048 11.1081C16.0909 10.7315 15.7115 10.7315 15.5922 11.1081Z",
    fill: "#EB8B29"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_821_34938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6027 10.9697L15.0712 12.6697C14.9627 13.0194 15.2231 13.3691 15.5918 13.3691H16.3782C16.747 13.3691 17.0073 13.014 16.8988 12.6697L16.3674 10.9697C16.2535 10.5931 15.722 10.5931 15.6027 10.9697Z",
    fill: "url(#paint44_linear_821_34938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6027 10.9697L15.0712 12.6697C14.9627 13.0194 15.2231 13.3691 15.5918 13.3691H16.3782C16.747 13.3691 17.0073 13.014 16.8988 12.6697L16.3674 10.9697C16.2535 10.5931 15.722 10.5931 15.6027 10.9697Z",
    fill: "url(#paint45_radial_821_34938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6027 10.9697L15.0712 12.6697C14.9627 13.0194 15.2231 13.3691 15.5918 13.3691H16.3782C16.747 13.3691 17.0073 13.014 16.8988 12.6697L16.3674 10.9697C16.2535 10.5931 15.722 10.5931 15.6027 10.9697Z",
    fill: "url(#paint46_linear_821_34938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6027 10.9697L15.0712 12.6697C14.9627 13.0194 15.2231 13.3691 15.5918 13.3691H16.3782C16.747 13.3691 17.0073 13.014 16.8988 12.6697L16.3674 10.9697C16.2535 10.5931 15.722 10.5931 15.6027 10.9697Z",
    fill: "url(#paint47_linear_821_34938)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6027 10.9697L15.0712 12.6697C14.9627 13.0194 15.2231 13.3691 15.5918 13.3691H16.3782C16.747 13.3691 17.0073 13.014 16.8988 12.6697L16.3674 10.9697C16.2535 10.5931 15.722 10.5931 15.6027 10.9697Z",
    fill: "url(#paint48_linear_821_34938)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6027 10.9697L15.0712 12.6697C14.9627 13.0194 15.2231 13.3691 15.5918 13.3691H16.3782C16.747 13.3691 17.0073 13.014 16.8988 12.6697L16.3674 10.9697C16.2535 10.5931 15.722 10.5931 15.6027 10.9697Z",
    fill: "url(#paint49_radial_821_34938)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.587 13.8536L14.587 13.8536L14.5865 13.8534C14.4935 13.805 14.3967 13.8353 14.3394 13.897C14.282 13.9588 14.2597 14.0573 14.3187 14.1447C14.6711 14.6907 15.2853 15.055 15.9851 15.055C16.685 15.055 17.2993 14.6906 17.6517 14.1443C17.7099 14.055 17.6888 13.9567 17.6305 13.8948C17.5727 13.8334 17.4759 13.8054 17.3836 13.8534L17.3836 13.8534L17.3831 13.8536C16.9792 14.069 16.503 14.1925 15.9851 14.1925C15.4723 14.1925 14.9909 14.069 14.587 13.8536Z",
    fill: "#8A004F",
    stroke: "url(#paint50_linear_821_34938)",
    strokeWidth: 0.1
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_i_821_34938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1273 10.7618C17.3927 10.295 17.7962 9.92627 18.6647 9.92627C19.0449 9.92627 19.4116 10.0316 19.7375 10.295C20.0063 10.5122 19.9703 10.7902 19.7621 10.8942L19.2061 11.2117C18.5543 11.001 17.8335 10.9725 17.1273 10.7618Z",
    fill: "#635D5F"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_i_821_34938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8434 10.7618C14.578 10.295 14.1745 9.92627 13.306 9.92627C12.9258 9.92627 12.5591 10.0316 12.2332 10.295C11.9644 10.5122 12.0004 10.7902 12.2086 10.8942L12.7646 11.2117C13.4165 11.001 14.1372 10.9725 14.8434 10.7618Z",
    fill: "#635D5F"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_i_821_34938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5873 9.55291L12.5829 9.55544C12.5828 9.55552 12.5827 9.5556 12.5825 9.55568C12.4556 9.63145 12.2911 9.59029 12.215 9.46346C12.1388 9.33645 12.1801 9.17163 12.3071 9.09542L12.3077 9.09508L12.3087 9.09447L12.3117 9.09273L12.3211 9.08728C12.3289 9.08282 12.3398 9.07671 12.3535 9.06926C12.381 9.05436 12.4201 9.03401 12.4695 9.01048C12.568 8.96351 12.7085 8.90337 12.8796 8.84875C13.2195 8.74027 13.6948 8.64902 14.2079 8.73956C14.3538 8.7653 14.4511 8.90441 14.4254 9.05027C14.3997 9.19613 14.2605 9.2935 14.1147 9.26776C13.716 9.1974 13.3331 9.26705 13.0427 9.35972C12.8988 9.40566 12.7811 9.45614 12.7003 9.49466C12.66 9.51387 12.6291 9.52997 12.6091 9.54084C12.599 9.54628 12.5917 9.55039 12.5873 9.55291Z",
    fill: "#BD4F26"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_i_821_34938)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7166 9.09542C19.7167 9.09547 19.7168 9.09552 19.5788 9.32548L19.7166 9.09542C19.8437 9.17163 19.885 9.33645 19.8088 9.46346C19.7327 9.59029 19.5683 9.63153 19.4414 9.55575C19.4413 9.5557 19.4411 9.55561 19.4409 9.55547L19.4365 9.55291C19.432 9.55039 19.4247 9.54628 19.4147 9.54084C19.3946 9.52997 19.3638 9.51387 19.3235 9.49466C19.2427 9.45614 19.125 9.40566 18.981 9.35972C18.6907 9.26705 18.3078 9.1974 17.9091 9.26776C17.7632 9.2935 17.6241 9.19613 17.5984 9.05027C17.5726 8.90441 17.67 8.7653 17.8159 8.73956C18.3289 8.64902 18.8042 8.74027 19.1441 8.84875C19.3153 8.90337 19.4557 8.96351 19.5543 9.01048C19.6036 9.03401 19.6427 9.05436 19.6702 9.06926C19.684 9.07671 19.6949 9.08282 19.7027 9.08728L19.7121 9.09273L19.715 9.09447L19.7161 9.09508L19.7166 9.09542Z",
    fill: "#BD4F26"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.376 9.98486C19.0291 9.98486 19.5808 10.4351 19.7309 11.0436C19.7755 11.2181 19.6416 11.3844 19.4632 11.3844H17.232C17.0901 11.3844 16.9765 11.2546 17.0049 11.1126C17.1306 10.4717 17.6945 9.98486 18.376 9.98486Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.169 10.2568C18.6639 10.2568 19.0614 10.6584 19.0614 11.1493C19.0614 11.2304 19.0492 11.3115 19.029 11.3846H17.3049C17.2846 11.3075 17.2725 11.2304 17.2725 11.1493C17.2725 10.6584 17.6741 10.2568 18.169 10.2568Z",
    fill: "url(#paint51_radial_821_34938)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6582 11.1491C17.6582 10.8651 17.8854 10.6379 18.1693 10.6379C18.4533 10.6379 18.6805 10.8651 18.6805 11.1491C18.6805 11.2343 18.6602 11.3154 18.6237 11.3844H17.7191C17.6785 11.3154 17.6582 11.2343 17.6582 11.1491Z",
    fill: "black"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_f_821_34938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1027 10.4455C18.1663 10.5304 18.0335 10.634 17.8825 10.7469C17.7315 10.8598 17.6195 10.9393 17.556 10.8543C17.4924 10.7693 17.5633 10.6089 17.7143 10.496C17.8653 10.3831 18.0392 10.3605 18.1027 10.4455Z",
    fill: "#C7A7A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1027 10.4455C18.1663 10.5304 18.0335 10.634 17.8825 10.7469C17.7315 10.8598 17.6195 10.9393 17.556 10.8543C17.4924 10.7693 17.5633 10.6089 17.7143 10.496C17.8653 10.3831 18.0392 10.3605 18.1027 10.4455Z",
    fill: "url(#paint52_radial_821_34938)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_f_821_34938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9635 11.0312C18.9306 10.8006 18.7957 10.6269 18.7323 10.5688L18.4727 10.8538L18.5898 11.0818L18.9635 11.0312Z",
    fill: "url(#paint53_linear_821_34938)"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.594 9.98486C12.9409 9.98486 12.3892 10.4351 12.2391 11.0436C12.1945 11.2181 12.3284 11.3844 12.5069 11.3844H14.738C14.88 11.3844 14.9936 11.2546 14.9652 11.1126C14.8394 10.4717 14.2715 9.98486 13.594 9.98486Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8007 10.2566C13.3058 10.2566 12.9082 10.6582 12.9082 11.149C12.9082 11.2302 12.9204 11.3113 12.9407 11.3843H14.6647C14.685 11.3073 14.6972 11.2302 14.6972 11.149C14.6931 10.6582 14.2956 10.2566 13.8007 10.2566Z",
    fill: "url(#paint54_radial_821_34938)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3123 11.1491C14.3123 10.8651 14.0851 10.6379 13.8012 10.6379C13.5172 10.6379 13.29 10.8651 13.29 11.1491C13.29 11.2343 13.3103 11.3154 13.3468 11.3844H14.2515C14.288 11.3154 14.3123 11.2343 14.3123 11.1491Z",
    fill: "black"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_f_821_34938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6156 11.0439C14.6156 10.7558 14.3813 10.5637 14.318 10.5056L14.0298 10.7843L14.2071 11.1453L14.6156 11.0439Z",
    fill: "url(#paint55_linear_821_34938)"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_f_821_34938)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5314,
    cy: 10.6381,
    rx: 0.389289,
    ry: 0.197016,
    transform: "rotate(-27.914 13.5314 10.6381)",
    fill: "#C7A7A3",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5314,
    cy: 10.6381,
    rx: 0.389289,
    ry: 0.197016,
    transform: "rotate(-27.914 13.5314 10.6381)",
    fill: "url(#paint56_radial_821_34938)"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_f_821_34938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9248 8.95817C18.2474 8.87971 19.0494 8.91894 19.5856 9.30253",
    stroke: "#C9725D",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_f_821_34938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1338 8.95817C13.8112 8.87971 13.0092 8.91894 12.473 9.30253",
    stroke: "#C9725D",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_f_821_34938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0907 5.31682C11.7118 4.7637 12.6076 4.75811 13.1104 4.84751L13.5127 6.13813C13.2557 6.09902 13.0266 6.18841 12.8339 6.37279C12.378 7.63324 10.8114 8.32827 10.085 8.51824C9.93418 7.02648 10.018 6.27222 11.0907 5.31682Z",
    fill: "url(#paint57_radial_821_34938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0907 5.31682C11.7118 4.7637 12.6076 4.75811 13.1104 4.84751L13.5127 6.13813C13.2557 6.09902 13.0266 6.18841 12.8339 6.37279C12.378 7.63324 10.8114 8.32827 10.085 8.51824C9.93418 7.02648 10.018 6.27222 11.0907 5.31682Z",
    fill: "url(#paint58_radial_821_34938)"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_f_821_34938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3819 3.54016C14.2492 3.29008 13.0353 4.49555 12.918 4.91458C14.46 8.53503 16.8279 8.18999 19.4549 7.8981C21.0275 7.72337 21.1981 8.44005 21.3321 8.78645C20.8964 4.73021 17.9631 4.11004 15.3819 3.54016Z",
    fill: "url(#paint59_radial_821_34938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3819 3.54016C14.2492 3.29008 13.0353 4.49555 12.918 4.91458C14.46 8.53503 16.8279 8.18999 19.4549 7.8981C21.0275 7.72337 21.1981 8.44005 21.3321 8.78645C20.8964 4.73021 17.9631 4.11004 15.3819 3.54016Z",
    fill: "url(#paint60_radial_821_34938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3819 3.54016C14.2492 3.29008 13.0353 4.49555 12.918 4.91458C14.46 8.53503 16.8279 8.18999 19.4549 7.8981C21.0275 7.72337 21.1981 8.44005 21.3321 8.78645C20.8964 4.73021 17.9631 4.11004 15.3819 3.54016Z",
    fill: "url(#paint61_radial_821_34938)"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_f_821_34938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0938 4.78882C13.117 5.03186 13.3284 5.94535 13.6385 6.49847",
    stroke: "url(#paint62_linear_821_34938)",
    strokeWidth: 0.1,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_821_34938",
    x: 8.47607,
    y: 2.55273,
    width: 15.2681,
    height: 15.2681,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25,
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.92549 0 0 0 0 0.537255 0 0 0 0 0.12549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_821_34938"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_821_34938",
    x: 5,
    y: 15.4675,
    width: 22.5,
    height: 14.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.439216 0 0 0 0 0.407843 0 0 0 0 0.552941 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_821_34938"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_821_34938",
    x: 9.21191,
    y: 15.8147,
    width: 6.55566,
    height: 14.595,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_821_34938"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_821_34938",
    x: 17.96,
    y: 16.2922,
    width: 3.9502,
    height: 13.3618,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375,
    result: "effect1_foregroundBlur_821_34938"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_821_34938",
    x: 10.5029,
    y: 16.0574,
    width: 2.89688,
    height: 13.9999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.403922 0 0 0 0 0.368627 0 0 0 0 0.494118 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_821_34938"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_821_34938",
    x: 14.5094,
    y: 18.1947,
    width: 2.96465,
    height: 2.88271,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156863 0 0 0 0 0.0980392 0 0 0 0 0.215686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_821_34938"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156863 0 0 0 0 0.0980392 0 0 0 0 0.215686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_821_34938",
    result: "effect2_innerShadow_821_34938"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_821_34938",
    x: 18.61,
    y: 16.0076,
    width: 2.90225,
    height: 14.05,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.439216 0 0 0 0 0.415686 0 0 0 0 0.584314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_821_34938"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_821_34938",
    x: 9.69043,
    y: 9.72168,
    width: 3.31826,
    height: 3.21826,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.768627 0 0 0 0 0.501961 0 0 0 0 0.160784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_821_34938"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_821_34938",
    x: 19.2031,
    y: 9.47168,
    width: 3.21826,
    height: 3.46826,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.937255 0 0 0 0 0.576471 0 0 0 0 0.341176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_821_34938"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_821_34938",
    x: 19.2383,
    y: 9.75659,
    width: 3.14844,
    height: 3.14819,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_821_34938"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_821_34938",
    x: 9.99463,
    y: 10.0066,
    width: 2.64844,
    height: 2.64819,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_821_34938"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_821_34938",
    x: 10.8896,
    y: 6.42407,
    width: 10.1909,
    height: 11.2767,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.92549 0 0 0 0 0.529412 0 0 0 0 0.137255 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_821_34938"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_821_34938",
    x: 14.3838,
    y: 10.3257,
    width: 2.87744,
    height: 3.68188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_821_34938"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_821_34938",
    x: 14.7964,
    y: 10.4373,
    width: 2.37744,
    height: 3.18188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_821_34938"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_i_821_34938",
    x: 16.9274,
    y: 9.92627,
    width: 3.00127,
    height: 1.2854,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.141176 0 0 0 0 0.0862745 0 0 0 0 0.176471 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_821_34938"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_i_821_34938",
    x: 12.042,
    y: 9.92627,
    width: 3.00127,
    height: 1.2854,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.0784314 0 0 0 0 0.168627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_821_34938"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_i_821_34938",
    x: 12.1768,
    y: 8.50264,
    width: 2.45293,
    height: 1.09111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.658824 0 0 0 0 0.270588 0 0 0 0 0.141176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_821_34938"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_i_821_34938",
    x: 17.5942,
    y: 8.50264,
    width: 2.45293,
    height: 1.09111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.658824 0 0 0 0 0.270588 0 0 0 0 0.141176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_821_34938"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_f_821_34938",
    x: 17.4327,
    y: 10.294,
    width: 0.786426,
    height: 0.69585,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_821_34938"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_821_34938",
    x: 18.2727,
    y: 10.3688,
    width: 0.890723,
    height: 0.912939,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_821_34938"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_f_821_34938",
    x: 13.8298,
    y: 10.3056,
    width: 0.985938,
    height: 1.03965,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_821_34938"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_f_821_34938",
    x: 13.0753,
    y: 10.286,
    width: 0.912402,
    height: 0.70415,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_821_34938"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_f_821_34938",
    x: 17.4247,
    y: 8.42471,
    width: 2.66084,
    height: 1.37788,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2,
    result: "effect1_foregroundBlur_821_34938"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_f_821_34938",
    x: 11.973,
    y: 8.42471,
    width: 2.66084,
    height: 1.37788,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2,
    result: "effect1_foregroundBlur_821_34938"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_f_821_34938",
    x: 9.27734,
    y: 4.05469,
    width: 4.98535,
    height: 5.21362,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375,
    result: "effect1_foregroundBlur_821_34938"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_f_821_34938",
    x: 12.668,
    y: 3.25635,
    width: 8.91406,
    height: 5.78003,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_821_34938"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_f_821_34938",
    x: 12.7939,
    y: 4.48877,
    width: 1.14453,
    height: 2.30981,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_821_34938"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_821_34938",
    x1: 20.6784,
    y1: 4.37831,
    x2: 13.4371,
    y2: 17.8209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD93C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E37923"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.414 13.3644) rotate(90) scale(4.45645 2.68487)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9641B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D77117",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.9851 13.457) rotate(90) scale(5.57099 5.8032)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.617268,
    stopColor: "#E26B25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E26B25",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.0746 11.6517) rotate(127.617) scale(2.03275 1.97369)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161391,
    stopColor: "#C9681C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9681C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6656 9.21504) rotate(100.537) scale(2.55689 2.66252)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365444,
    stopColor: "#D76A18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D76A18",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.6485 4.16798) rotate(62.6046) scale(2.38097 4.53569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.221806,
    stopColor: "#CBA140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921111,
    stopColor: "#CBA140",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.4829 5.58513) rotate(132.51) scale(1.63713 2.28786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDF3C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.4942 10.4794) rotate(163.779) scale(1.9201 4.17788)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD336",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD537",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.6183 18.2526) rotate(-133.315) scale(4.66215 6.69539)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB6325"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB6325",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2803 6.66257) rotate(-90.3515) scale(1.37439 0.450618)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.295258,
    stopColor: "#DB6009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB6009",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_821_34938",
    x1: 15.9999,
    y1: 16.2791,
    x2: 15.9999,
    y2: 31.2166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#594E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#594984"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9949 25.4603) rotate(-90) scale(16.4313 6.37009)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155797,
    stopColor: "#7B74A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F5490",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 23.0324) rotate(90) scale(10.1215 4.59696)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.397031,
    stopColor: "#C6BBD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A89CB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_821_34938",
    x1: 18.9031,
    y1: 25.2789,
    x2: 17.0593,
    y2: 25.2789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A6C85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7BCD2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_821_34938",
    x1: 15.5906,
    y1: 17.8258,
    x2: 15.6687,
    y2: 21.7164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#877F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#877F93",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25 29.9674) rotate(-90) scale(10.3135 1.68433)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#776D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D6193"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_821_34938",
    x1: 23,
    y1: 29.4543,
    x2: 23.7438,
    y2: 29.4306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.275571,
    stopColor: "#504176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#504176",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_821_34938",
    x1: 11.9013,
    y1: 16.0574,
    x2: 11.9013,
    y2: 29.9574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#594B78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524033,
    stopColor: "#5D5087"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_821_34938",
    x1: 13.6707,
    y1: 22.5167,
    x2: 13.0498,
    y2: 22.5167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#553A63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#553A63",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.7153 16.3414) rotate(126.18) scale(2.59394 3.59462)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E3360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E3360",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_821_34938",
    x1: 11.9013,
    y1: 25.9334,
    x2: 12.8385,
    y2: 25.5319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.195813,
    stopColor: "#594C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#594C7D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.395 19.7242) rotate(-15.9454) scale(1.13752 0.559025)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.241347,
    stopColor: "#4B3B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B3B6D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_821_34938",
    x1: 12.2231,
    y1: 16.0574,
    x2: 12.4341,
    y2: 16.4586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#584360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#584360",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_821_34938",
    x1: 15.9884,
    y1: 18.9509,
    x2: 15.9884,
    y2: 20.9353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#5A3859"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463952"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_821_34938",
    x1: 18.71,
    y1: 21.5644,
    x2: 20.111,
    y2: 21.5644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0932249,
    stopColor: "#5A4C74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#625A91",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 18.4822) rotate(90) scale(3.75 4.3769)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3625,
    stopColor: "#CDBED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A093A3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 20.9793) rotate(-90) scale(5.1875 6.81546)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.532569,
    stopColor: "#9D8392",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875943,
    stopColor: "#815A72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_821_34938",
    x1: 9.45187,
    y1: 23.9749,
    x2: 7.01987,
    y2: 23.9749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43395F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43395F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.983 21.3727) rotate(90) scale(8.8125 3.45478)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#59416D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939716,
    stopColor: "#3D3247"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_821_34938",
    x1: 14.6063,
    y1: 24.8375,
    x2: 14.8993,
    y2: 24.8766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B1B3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B1B3A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_821_34938",
    x1: 17.411,
    y1: 24.6539,
    x2: 17.0126,
    y2: 24.7008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B1B3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B1B3A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.0293 17.2283) rotate(90) scale(2.48828 3.72875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.271586,
    stopColor: "#DD8931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A85F21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_821_34938",
    x1: 9.69043,
    y1: 11.4179,
    x2: 12.6497,
    y2: 11.4179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E79B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B96201"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.0245 11.7699) rotate(-24.444) scale(2.73412 3.33824)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.572298,
    stopColor: "#FFC531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904617,
    stopColor: "#FFE549"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.5778 11.5687) rotate(-20.2976) scale(1.30459)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.71002,
    stopColor: "#FFBA25",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA25"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.3187 11.3307) rotate(180) scale(1.07411 1.02745)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.415002,
    stopColor: "#D67923",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D67923"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.8443 10.7934) rotate(155.244) scale(7.16175 9.58588)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB9235"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8854 11.4908) rotate(152.124) scale(2.38668 2.02493)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE842",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.8054 17.576) rotate(-78.3106) scale(4.1308 5.24122)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4883F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4883F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.7233 10.3097) rotate(90) scale(7.44059 11.8177)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.592664,
    stopColor: "#F3943B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D97C39"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.6125 12.4498) rotate(164.542) scale(5.62608 9.68637)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.876514,
    stopColor: "#D4993E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4993E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.2864 10.3749) rotate(-90) scale(1.15077 1.41231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB31",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0669 10.4621) rotate(-90) scale(1.36 1.55865)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F09429",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.0805 11.8625) rotate(-180) scale(1.34695 4.43421)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDA39",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_821_34938",
    x1: 15.985,
    y1: 13.3691,
    x2: 15.985,
    y2: 10.6873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8C73F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.7694 12.5893) rotate(-105.892) scale(2.54709 1.45748)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0168227,
    stopColor: "#FFE848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE848",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_821_34938",
    x1: 14.9386,
    y1: 12.6067,
    x2: 15.793,
    y2: 12.7113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A322",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_821_34938",
    x1: 15.985,
    y1: 13.4611,
    x2: 15.985,
    y2: 12.8508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E48538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E48538",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_821_34938",
    x1: 16.0632,
    y1: 13.4349,
    x2: 16.0632,
    y2: 13.2954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2802F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2802F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.2725 12.2318) rotate(144.462) scale(1.57489 2.10945)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.797297,
    stopColor: "#E2802F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2802F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_821_34938",
    x1: 15.256,
    y1: 14.938,
    x2: 15.7086,
    y2: 14.0664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEAC35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEAC35",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.1669 10.7339) rotate(90) scale(0.811316 1.29049)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.80198,
    stopColor: "#925C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#694B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#804D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85534D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.9383 10.8177) rotate(-127.812) scale(0.377981 0.520389)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.765532,
    stopColor: "#FFE6E2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966159,
    stopColor: "#FFE6E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_821_34938",
    x1: 18.9445,
    y1: 10.7873,
    x2: 18.631,
    y2: 10.9805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4948D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4948D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.8027 10.7336) rotate(90) scale(0.811321 1.2905)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.80198,
    stopColor: "#925C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#694B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#804D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85534D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_821_34938",
    x1: 14.5462,
    y1: 10.7874,
    x2: 14.2327,
    y2: 10.9806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4948D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4948D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5164 10.9527) rotate(-90.897) scale(0.493721 0.593473)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.765532,
    stopColor: "#FFE6E2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966159,
    stopColor: "#FFE6E2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2697 4.37819) rotate(129.554) scale(5.36951 2.34181)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.395696,
    stopColor: "#EE971B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911046,
    stopColor: "#D8772C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.1301 4.92551) rotate(144.458) scale(3.81321 1.88454)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.120488,
    stopColor: "#FFCA2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE134",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA2D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.7766 3.20566) rotate(115.63) scale(5.05214 7.1732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.627022,
    stopColor: "#F49523",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49523"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.494 4.45896) rotate(105.909) scale(3.44004 7.20923)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.131886,
    stopColor: "#FFE337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE337",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_821_34938",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.1349 10.0904) rotate(-117.848) scale(7.31454 6.53874)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.897563,
    stopColor: "#CA9B37",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA9B37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_821_34938",
    x1: 13.0937,
    y1: 5.13243,
    x2: 13.6385,
    y2: 6.40628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB6008"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeWorker);
export default __webpack_public_path__ + "static/media/OfficeWorker.3b5732d28f607fcd5aeb9fa8e1256ac3.svg";
export { ForwardRef as ReactComponent };